import React, { FC, useEffect, useState } from 'react';
import {
  Route,
  Switch, useRouteMatch,
} from 'react-router-dom';

import V1Main from '../pages/V1/Main';
import V2Main from '../pages/V2/Main';
import FetchCode from '../pages/V2/FetchCode';
import { parseUrlParams } from '../lib/utils/utils';
import {
  LargeLocker1_1,
  LargeLocker1_2,
  LargeLocker1_3,
  LargeLocker1_4,
  LargeLocker2_1,
  LargeLocker2_2,
  LargeLocker2_3,
  LargeLocker2_4,
} from '../assets/Images/cab-size/large-locker';
import {
  RegularLocker1_1,
  RegularLocker1_2,
  RegularLocker1_3,
  RegularLocker2_1,
  RegularLocker2_2,
  RegularLocker2_3,
  RegularLocker2_4,
  RegularLocker3_1,
  RegularLocker3_2,
  RegularLocker3_3,
  RegularLocker3_4,
  RegularLocker4_1,
  RegularLocker4_2,
  RegularLocker5_1,
  RegularLocker5_2,
  RegularLocker5_3,
  RegularLocker5_4,
} from '../assets/Images/cab-size/regular-locker';

const preloadImage = (src: string) => {
  const img = new Image();
  img.src = src;
};

const Master: FC<Props> = ({ cabId32Str, setCabId32Str }) => {
  const params = parseUrlParams<{ cabId: string; visitorId: string; firebaseId: string; version?: string }>(window.location.href);
  const [version, setVersion] = useState(params.version);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const { path } = useRouteMatch();

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

    const handleChange = (event: any) => {
      setIsDarkMode(event.matches);
    };

    // 初始检查
    setIsDarkMode(mediaQuery.matches);

    // 监听系统主题变化
    mediaQuery.addEventListener('change', handleChange);

    // 组件卸载时移除监听器
    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);

  /**
   * 需要提前加载的图片
   */
  useEffect(() => {
    const imageList = [
      LargeLocker1_1,
      LargeLocker1_2,
      LargeLocker1_3,
      LargeLocker1_4,
      LargeLocker2_1,
      LargeLocker2_2,
      LargeLocker2_3,
      LargeLocker2_4,
      RegularLocker1_1,
      RegularLocker1_2,
      RegularLocker1_3,
      RegularLocker2_1,
      RegularLocker2_2,
      RegularLocker2_3,
      RegularLocker2_4,
      RegularLocker3_1,
      RegularLocker3_2,
      RegularLocker3_3,
      RegularLocker3_4,
      RegularLocker4_1,
      RegularLocker4_2,
      RegularLocker5_1,
      RegularLocker5_2,
      RegularLocker5_3,
      RegularLocker5_4,
    ];
    imageList.map(src => preloadImage(src));
  }, []);

  return (
    <Switch>
      {/* TODO 临时关闭V1版本，统一进入V2版本，2025-06-03 */}
      {/*<Route path="/main">*/}
      {/*  {*/}
      {/*    (cabId32Str != null && cabId32Str !== '' && (!version || version.toLowerCase() === 'v1')) && (*/}
      {/*      <V1Main cabId32Str={cabId32Str} />*/}
      {/*    )*/}
      {/*  }*/}
      {/*  {*/}
      {/*    (cabId32Str == null || cabId32Str === '') && (!version || version.toLowerCase() === 'v2') && (*/}
      {/*      <V2Main*/}
      {/*        setVersion={setVersion}*/}
      {/*        cabId32Str={cabId32Str}*/}
      {/*        setCabId32Str={setCabId32Str}*/}
      {/*      />*/}
      {/*    )*/}
      {/*  }*/}
      {/*  {*/}
      {/*    cabId32Str != null && version && version.toLowerCase() === 'v2' && (*/}
      {/*      <V2Main*/}
      {/*        setVersion={setVersion}*/}
      {/*        cabId32Str={cabId32Str}*/}
      {/*        setCabId32Str={setCabId32Str}*/}
      {/*      />*/}
      {/*    )*/}
      {/*  }*/}
      {/*</Route>*/}
      <Route path="/main">
        <V2Main
          setVersion={setVersion}
          cabId32Str={cabId32Str}
          setCabId32Str={setCabId32Str}
        />
      </Route>
      <Route path="/fetch-code">
        <FetchCode isDarkMode={isDarkMode} />
      </Route>
    </Switch>
  );
};

export interface Props {
  cabId32Str: string;
  setCabId32Str: (cabId32Str: string) => void;
}

export default Master;
